<div class="app-policy-field-effective-policy-settings-button">
  <button
    class="confirm"
    type="submit"
    (click)="buttonClicked()"
    [disabled]="isDisabled"
    [matTooltip]="tooltipText"
    [matTooltipDisabled]="!isDisabled"
  >
    {{ 'View Rules' }}
  </button>
</div>
